/**
 * Breadcrumbs Filter State Restoration
 * Modifies "Files" link in breadcrumbs to preserve filter state
 */
(function() {
    'use strict';

    /**
     * Restore filter URL in breadcrumbs
     */
    function restoreBreadcrumbFiltersUrl() {
        // Get saved URL from localStorage
        const savedUrl = localStorage.getItem('filesPageLastUrl');
        
        if (!savedUrl) {
            return; // No saved URL
        }

        // Find all links in breadcrumbs
        const breadcrumbLinks = document.querySelectorAll('.breadcrumb a, .position-breadcrumb a');
        
        breadcrumbLinks.forEach(link => {
            const href = link.getAttribute('href');
            
            // Check if link points to /files/ (with or without parameters)
            if (href && (
                href === '/files/' || 
                href === '/files' ||
                href.includes('/files/?') ||
                href.includes('localhost/files/') ||
                href.match(/\/files\/(\?|$)/)
            )) {
                // Replace with saved URL with parameters
                const newHref = savedUrl;
                link.setAttribute('href', newHref);
                
                console.log('Breadcrumb restored:', {
                    original: href,
                    restored: newHref
                });
            }
        });
    }

    /**
     * Clear saved URL if user directly navigates to /files/ without parameters
     */
    function clearFiltersIfDirectVisit() {
        // If we're on /files/ WITHOUT parameters - clear localStorage
        if (window.location.pathname === '/files/' && !window.location.search) {
            // Check if this was a direct visit (not from breadcrumbs)
            const referrer = document.referrer;
            const isFromSingleFile = referrer.includes('/files/') && 
                                     referrer.match(/\/files\/[^\/]+\//);
            
            if (!isFromSingleFile) {
                localStorage.removeItem('filesPageLastUrl');
                console.log('Filters cache cleared: direct visit to /files/');
            }
        }
    }

    // Execute after DOM loads
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            restoreBreadcrumbFiltersUrl();
            clearFiltersIfDirectVisit();
        });
    } else {
        // DOM already loaded
        restoreBreadcrumbFiltersUrl();
        clearFiltersIfDirectVisit();
    }

})();
